// Debug - Log when file is loaded
console.log("PunchAttack.js is being loaded");

/**
 * PunchAttack.js
 * Specific implementation for punch attacks
 */

import { MeleeSystem } from './MeleeSystem.js';
import * as THREE from 'three';

export class PunchAttack {
  constructor(scene, player) {
    console.log("PunchAttack constructor called with scene:", !!scene, "player:", !!player);
    this.scene = scene;
    this.player = player;
    this.name = "Punch";
    this.equipped = true; // Always "equipped" as it's the default attack
    
    // Create melee system for handling core mechanics
    this.meleeSystem = new MeleeSystem(scene);
    
    // Reference to the player's strength skill
    this.strengthSkill = null;
    
    // Make punch attack globally accessible for debugging
    window.punchAttack = this;
    
    console.log("PunchAttack initialized");
  }
  
  /**
   * Set the strength skill reference for damage calculation
   * @param {Object} strengthSkill - The player's strength skill
   */
  setStrengthSkill(strengthSkill) {
    console.log("Setting strength skill:", !!strengthSkill);
    this.strengthSkill = strengthSkill;
  }
  
  /**
   * Performs a punch attack
   * @returns {boolean} True if the attack was performed, false if on cooldown
   */
  fire() {
    console.log("PunchAttack fire() method called");
    if (!this.player) {
      console.error("No player reference in PunchAttack");
      return false;
    }
    
    // Trigger punch animation on player model if available
    if (this.player.getPlayerModel) {
      const playerModel = this.player.getPlayerModel();
      console.log("Player model available for animation:", !!playerModel);
      if (playerModel && playerModel.triggerPunchAnimation) {
        playerModel.triggerPunchAnimation();
      } else {
        console.warn("Player model doesn't have triggerPunchAnimation method");
      }
    } else {
      console.warn("Player does not have getPlayerModel method");
    }
    
    // Perform the attack
    const hitInfo = this.meleeSystem.performAttack(this.player, this.strengthSkill);
    console.log("Attack result:", hitInfo ? "hit something" : "missed");
    
    // If we hit something, give XP (commented out for now as the XP system is for future)
    /*
    if (hitInfo && this.strengthSkill) {
      // Award XP based on the hit
      this.strengthSkill.addXP(10);
    }
    */
    
    return hitInfo !== null;
  }
  
  /**
   * Get the cooldown status
   * @returns {boolean} True if attack is on cooldown
   */
  isOnCooldown() {
    return !this.meleeSystem.canAttack();
  }
  
  /**
   * Gets the punch range
   * @returns {number} Range in units
   */
  getRange() {
    return this.meleeSystem.range;
  }
  
  /**
   * Gets the current damage based on strength level
   * @returns {number} Damage amount
   */
  getDamage() {
    return this.strengthSkill ? this.strengthSkill.getDamage() : 15;
  }
  
  /**
   * Toggle debug visualization
   * @param {boolean} enabled - Enable debug visualization
   */
  setDebug(enabled) {
    this.meleeSystem.setDebug(enabled);
  }
  
  // Make the punch compatible with the weapon system interface
  equip() {
    this.equipped = true;
    return true;
  }
  
  unequip() {
    // Can't really unequip a punch, but we'll set the flag anyway
    this.equipped = false;
    return true;
  }
} 